'use strict';
require('../../../modules/es.array.for-each');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('Array', 'forEach');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/for-each.js
// module id = 559
// module chunks = 13